/**
 * Public rating API client: the secret in the WhatsApp link is the key.
 *   GET  {BASE}/api/v1/customer-feedback/public/:token
 *   POST {BASE}/api/v1/customer-feedback/public/:token
 */

const BASE = process.env.REACT_APP_API_URL ?? 'http://localhost:4000';

export type RatingInfo = {
  customerName: string | null;
  boxes: string[];
  rated: boolean;
  rating: number | null;
  googleReviewUrl: string | null;
};

export type RatingPayload = {
  rating: number;
  comment?: string;
  reasons?: string[];
  photos?: File[];
};

export class RatingError extends Error {
  constructor(message: string, readonly status: number) {
    super(message);
  }
}

async function call(token: string, init?: RequestInit): Promise<RatingInfo> {
  const res = await fetch(
    `${BASE}/api/v1/customer-feedback/public/${encodeURIComponent(token)}`,
    init,
  );
  const json = await res.json().catch(() => null);
  if (!res.ok) {
    throw new RatingError(json?.message ?? 'Something went wrong', res.status);
  }
  return json?.data ?? json;
}

export const getRatingInfo = (token: string) => call(token);

export const submitRating = (token: string, p: RatingPayload) => {
  const body = new FormData();
  body.append('rating', String(p.rating));
  if (p.comment) body.append('comment', p.comment);
  (p.reasons ?? []).forEach((r) => body.append('reasons', r));
  (p.photos ?? []).forEach((f) => body.append('photos', f));
  return call(token, { method: 'POST', body });
};
